import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext'; // ✅ import this

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <AuthProvider>   {/* ✅ wrap here */}
      <HelmetProvider>
      <App />
    </HelmetProvider>
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();